import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMembersKey, getMemberKey } from '../../utils/keys';
export const useDeleteMember = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.members.delete(input), {
        onSettled: (data, error, input) => {
            const memberKey = getMemberKey({ variables: { id: input.id } });
            queryClient.removeQueries(memberKey);
            const membersKey = getMembersKey();
            queryClient.invalidateQueries(membersKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useDeleteMember.js.map